import { render } from "./ProfitLossAnalytics.vue?vue&type=template&id=a5011e20&scoped=true"
import script from "./ProfitLossAnalytics.vue?vue&type=script&lang=js"
export * from "./ProfitLossAnalytics.vue?vue&type=script&lang=js"

import "./ProfitLossAnalytics.vue?vue&type=style&index=0&id=a5011e20&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5011e20"]])

export default __exports__